import store from "@/store";

export default function copyToClipboard( val ) {
	const tempInput = document.createElement( "input" );

	tempInput.style = "position: absolute; left: -1000px; top: -1000px";
	tempInput.value = val;
	document.body.appendChild( tempInput );
	tempInput.select();
	document.execCommand( "copy" );
	document.body.removeChild( tempInput );

	store.commit( "toasts/SHOW", {
		color: "success",
		text: "Copied to clipboard"
	} );
}
